import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/service/group/`,
    detail: (id) => `${BASE_URL}/api/v1/service/group/${id}/`,
};

export const serviceGroupLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const serviceGroupDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const serviceGroupUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const serviceGroupDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
